<template>
  <div class="text-container">
    <p class="black--text mb-1">{{ text }}</p>
    <v-progress-linear color="primary" indeterminate v-if="showprogress"></v-progress-linear>
  </div>
</template>

<script>
  export default {
    name: 'CenteredText',
    props: ['text', 'showprogress', 'blacktext'],
  };
</script>

<style>
  .text-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    color: var(--v-black-base);
    /* position: absolute;
    z-index: 2;
    background-color: transparent; */
  }
</style>
